<div class="proto-image__inner"
     [ngClass]="{
    'no-auto-height': imageType !== 'default' && imageType !== 'original',
    'has-loaded': imageStatus === 'loaded',
    'has-error': imageStatus === 'error',
    'has-placeholder': showPlaceholderImage }"
     [ngStyle]="{
    'background-image': (image && image.urls.preload) ? 'url(' + image.urls.preload + ')' : 'none' }"
     (click)="onImageClicked()">
  <img class="proto-image-source"
       #ImageElement
       [attr.data-src]="image ? image.urls[imageType] : ''"
       (error)="onImageError()"
       (load)="onImageLoaded()"/>

  <!-- static elements (e.g. title, description, badge, etc.) -->
  <ng-content select=".proto-image-content"></ng-content>

  <!-- buttons (e.g. image edit, upload, etc.) -->
  <ng-content select=".proto-image-buttons"></ng-content>
</div>
